import AlYusrAxiosApiInstance from "../axios/alYusrAxiosApiInstance";
import { AlYuserApiUrls } from "../configuration";
import { ResponseBaseModel } from "../models";
import { ClientFeatureSettingModel } from "../models/systemConfiugration/clientFeatureSettingModal";
import { handleError } from "../utils";

export const getClientFeatures =
  async (): Promise<ClientFeatureSettingModel | null> => {
    try {
      const result: ResponseBaseModel<ClientFeatureSettingModel> =
        await AlYusrAxiosApiInstance.get(
          AlYuserApiUrls.systemSettingController.getClientFeatures
        );

      return result && result.Result ? { ...result?.Result } : null;
    } catch (err) {
      alert(handleError(err));
    }
    return null;
  };
